import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getBreakpointFromManor } from 'ctm-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    tableSectionHeaderContainer: {
        backgroundColor: theme.colors.primary50,
        color: theme.colors.grey900,
        extend: ({ breakpoint }) => {
            if (breakpoint === 'xs') {
                return {
                    paddingTop: theme.spacing[12],
                    paddingBottom: theme.spacing[12],
                    paddingLeft: '1.5rem',
                    fontSize: theme.fontSize.lg,
                    fontWeight: theme.fontWeight.normal,
                    lineHeight: '2.2rem'
                };
            }
            return {
                paddingTop: '1.1rem',
                paddingBottom: theme.spacing[16],
                paddingLeft: '1.8rem',
                fontSize: theme.fontSize.xl,
                fontWeight: theme.fontWeight.normal,
                lineHeight: '2.5rem'
            };
        }
    },
    inherit: {
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit'
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        color: theme.colors.primary500,
        marginRight: '1rem'
    }
}));

const TableSectionHeader = (props) => {
    const { className, isKeyInformation } = props;
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    return (
        <div className={classNames(classes.tableSectionHeaderContainer, className)}>
            {
                isKeyInformation
                    ? <Typography className={classes.inherit}>Key Information</Typography>
                    : (
                        <div className={classes.iconContainer}>
                            <FontAwesomeIcon icon={faFile} className={classes.icon} />
                            <Typography className={classes.inherit}>Features & Benefits</Typography>
                        </div>
                    )
            }
        </div>
    );
};

TableSectionHeader.propTypes = {
    className: PropTypes.string,
    isKeyInformation: PropTypes.bool
};

export { TableSectionHeader };
